var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.0371 102.019V110.815H58.713H60.2743H60.9693V102.019H58.0371Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3996 105.893L64.8516 106.097L65.4294 110.491L66.9775 110.287L66.3996 105.893Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4114 104.576L70.9033 104.98L72.0502 109.261L73.5583 108.857L72.4114 104.576Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2052 102.503L76.7627 103.1L78.4582 107.194L79.9007 106.597L78.2052 102.503Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7811 102.5L39.0874 106.596L40.5302 107.192L42.2239 103.097L40.7811 102.5Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5713 104.577L45.4258 108.858L46.934 109.262L48.0795 104.981L46.5713 104.577Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5893 105.878L52.0083 110.271L53.5562 110.476L54.1371 106.082L52.5893 105.878Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.974 7.91821H58.0371V16.7099H60.974V7.91821Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9028 23.1597L39.4493 21.6936L35.0511 14.0776L34.4466 14.4251L34.4418 14.4204L33.09 15.201L33.0948 15.2058L32.5093 15.5437L36.9028 23.1597Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M82.101 95.5691L79.5576 97.0378L83.9567 104.656L86.5001 103.187L82.101 95.5691Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8279 39.3104L23.2988 36.7686L15.6828 32.3704L15.3353 32.9701L15.3258 32.9654L14.5451 34.3172L14.5546 34.322L14.2119 34.9122L21.8279 39.3104Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1821 79.4264L95.7134 81.9697L103.331 86.3688L104.8 83.8255L97.1821 79.4264Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05249 57.8982V58.5836H8.04297V60.1449H8.05249V60.8351H16.849V57.8982H8.05249Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M110.954 57.8982H102.158V60.8351H110.954V57.8982Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8279 79.4229L14.2119 83.8211L14.5546 84.4113L14.5451 84.4161L15.3258 85.7679L15.3353 85.7632L15.6828 86.3629L23.2988 81.9647L21.8279 79.4229Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M103.331 32.3675L95.7134 36.7666L97.1821 39.31L104.8 34.9109L103.331 32.3675Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9028 95.5737L32.5093 103.19L33.0948 103.528L33.09 103.532L34.4418 104.313L34.4466 104.308L35.0511 104.656L39.4493 97.0398L36.9028 95.5737Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9621 14.0702L79.563 21.688L82.1064 23.1567L86.5055 15.539L83.9621 14.0702Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5505 8.25637L52.0024 8.45996L52.5803 12.8539L54.1283 12.6503L53.5505 8.25637Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46.926 9.4663L45.418 9.87036L46.5649 14.1508L48.0729 13.7467L46.926 9.4663Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5211 11.535L39.0786 12.1323L40.7741 16.2266L42.2166 15.6293L40.5211 11.535Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7901 18.0737L27.5513 19.0239L30.2483 22.5404L31.4872 21.5902L28.7901 18.0737Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7312 96.1823L87.4927 97.1328L90.1906 100.648L91.4292 99.6979L88.7312 96.1823Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6635 22.4336L22.5596 23.5376L25.6931 26.6711L26.7971 25.5672L23.6635 22.4336Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2886 92.0628L92.1846 93.1667L95.3181 96.3003L96.4221 95.1963L93.2886 92.0628Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1497 27.4297L18.1992 28.6682L21.7148 31.3661L22.6653 30.1276L19.1497 27.4297Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M97.269 87.3746L96.3184 88.613L99.8335 91.3114L100.784 90.073L97.269 87.3746Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.258 38.956L11.6606 40.3984L15.755 42.0939L16.3523 40.6515L12.258 38.956Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M103.223 76.6354L102.626 78.0779L106.72 79.7734L107.318 78.3309L103.223 76.6354Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99927 45.2974L9.59521 46.8054L13.8757 47.9523L14.2797 46.4443L9.99927 45.2974Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M105.109 70.7923L104.705 72.3003L108.985 73.4472L109.389 71.9391L105.109 70.7923Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58705 51.8756L8.3833 53.4236L12.7772 54.0019L12.9809 52.4539L8.58705 51.8756Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M106.208 64.7274L106.005 66.2754L110.399 66.8533L110.602 65.3053L106.208 64.7274Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7724 64.7242L8.37891 65.3025L8.58265 66.8503L12.9761 66.272L12.7724 64.7242Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M110.41 51.8814L106.016 52.4592L106.219 54.0072L110.613 53.4294L110.41 51.8814Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8737 70.7769L9.59326 71.9238L9.99732 73.4319L14.2778 72.285L13.8737 70.7769Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M108.984 45.2911L104.704 46.438L105.108 47.946L109.388 46.7991L108.984 45.2911Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7579 76.6392L11.6636 78.3347L12.2609 79.7772L16.3552 78.0817L15.7579 76.6392Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M106.721 38.9607L102.627 40.6562L103.224 42.0987L107.319 40.4032L106.721 38.9607Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7172 87.3685L18.2017 90.0664L19.1522 91.305L22.6677 88.607L21.7172 87.3685Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8315 27.4337L96.3164 30.1321L97.2671 31.3705L100.782 28.6721L99.8315 27.4337Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6902 92.0608L22.5566 95.1943L23.6606 96.2983L26.7942 93.1648L25.6902 92.0608Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3196 22.4321L92.186 25.5657L93.29 26.6697L96.4236 23.5361L95.3196 22.4321Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2526 96.1844L27.5547 99.7L28.7933 100.65L31.4912 97.1349L30.2526 96.1844Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1862 18.0709L87.4883 21.5864L88.7269 22.5369L91.4248 19.0214L90.1862 18.0709Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4631 11.5319L76.7681 15.6267L78.2107 16.2239L79.9058 12.1291L78.4631 11.5319Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0483 9.47395L70.9019 13.7544L72.4099 14.1583L73.5563 9.87785L72.0483 9.47395Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4304 8.25527L64.8525 12.6492L66.4005 12.8528L66.9784 8.45886L65.4304 8.25527Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3672 78.1331H40.6299V82.9073H78.3672V78.1331Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3673 35.8213H41.6392V40.5956H78.3673V35.8213Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3378 56.8844C67.8952 55.2088 67.0146 53.6856 65.7913 52.4576C64.4918 51.1343 62.8401 50.2108 61.0312 49.792L74.84 43.2708L68.3378 56.8844Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1982 61.6682C50.0359 65.3001 52.8681 68.1418 56.4953 68.9986L42.5532 75.5817L49.1982 61.6682Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3953 61.792C55.0768 60.464 55.0816 58.322 56.4049 56.9987C57.7329 55.6802 59.8749 55.685 61.1982 57.0082C62.5167 58.3363 62.5119 60.4783 61.1887 61.8016C59.8559 63.1201 57.7139 63.1153 56.3953 61.792ZM62.4405 63.0534C64.4635 61.0447 64.4731 57.7746 62.4643 55.7516C60.4556 53.7286 57.1855 53.7191 55.1625 55.7278C53.1395 57.7365 53.13 61.0066 55.1387 63.0296C55.1435 63.0344 55.1435 63.0344 55.1482 63.0392C57.1569 65.0479 60.4175 65.0526 62.4405 63.0534Z",
    fill: "#0A2C4B",
    fillOpacity: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarImage);
export default __webpack_public_path__ + "static/media/sidebar-image.7950302c51205753d5482a1c89bf9cce.svg";
export { ForwardRef as ReactComponent };